export const mobileChannelListSelector = (state) => state.channelList.mobile;
export const desktopChannelListSelector = (state) => state.channelList.desktop;